var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Dialog, DialogActions } from "@mui/material";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { formatCurrency } from "../../util/utilitarios";
var BootstrapDialog = styled(Dialog)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
    });
});
function BootstrapDialogTitle(props) {
    var children = props.children, onClose = props.onClose, other = __rest(props, ["children", "onClose"]);
    return (_jsxs(DialogTitle, __assign({ sx: { m: 0, p: 1, backgroundColor: "#034EA2", color: "white" } }, other, { children: [children, onClose ? (_jsx(IconButton, __assign({ "aria-label": "close", onClick: onClose, sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: "white",
                } }, { children: _jsx(CloseIcon, {}) }))) : null] })));
}
export function DialogBoleto(props) {
    var handleClose = props.handleClose, generateBoleto = props.generateBoleto;
    var debito = props.debito, boleto = props.boleto;
    var _a = React.useState(true), open = _a[0], setOpen = _a[1];
    var handleDialogClose = function () {
        setOpen(false);
        handleClose();
    };
    return (_jsx(_Fragment, { children: _jsxs(BootstrapDialog, __assign({ onClose: handleDialogClose, "aria-labelledby": "customized-dialog-title", open: open, sx: {} }, { children: [_jsx(BootstrapDialogTitle, __assign({ id: "customized-dialog-title", onClose: handleClose }, { children: "Pagamento com boleto" })), _jsxs("div", __assign({ style: cardBody }, { children: [_jsxs(Alert, __assign({ severity: "warning" }, { children: ["O tempo de compensa\u00E7\u00E3o do boleto pode variar conforme o banco escolhido para pagamento.", " ", _jsx("b", { children: "Pagar preferencialmente no Banco do Brasil." })] })), _jsxs("div", __assign({ style: infoDescricao }, { children: [_jsx(Typography, __assign({ gutterBottom: true, fontWeight: "bold" }, { children: "C\u00F3digo de barras:" })), _jsx(Typography, __assign({ gutterBottom: true, fontWeight: "bold", fontSize: 14 }, { children: boleto === null || boleto === void 0 ? void 0 : boleto.codigoBarras }))] })), _jsxs("div", __assign({ style: __assign(__assign({}, contentInfoDescricao), { width: "100%" }) }, { children: [_jsx("span", __assign({ style: infoDescricao }, { children: _jsx(Typography, __assign({ gutterBottom: true, fontWeight: "bold", paddingRight: 1 }, { children: "Valor:" })) })), _jsx(Typography, __assign({ gutterBottom: true }, { children: formatCurrency(boleto === null || boleto === void 0 ? void 0 : boleto.total) }))] })), _jsx(DialogActions, { children: _jsx(Button, __assign({ color: "primary", onClick: function () { return null; } }, { children: "Gerar boleto" })) })] }))] })) }));
}
var cardBody = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 32px",
    gap: "10px",
};
var infoDescricao = {
    fontWeight: "bold",
};
var contentInfoDescricao = {
    display: "flex",
};
